import { useDateFormat } from '@vueuse/shared';
import hash from 'string-hash';
import randomSeed from 'random-seed';
import { PERMITTED_CHAT_COLORS } from '@/constants/chat-variables';

export const formattedDate = (date, dateFormat = import.meta.env.VITE_DATETIME_FORMAT || 'YYYY-MM-DD, HH:mm:ss') => {
    if (!date) return null;
    return useDateFormat(date, dateFormat).value;
};

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) {
        return '0';
    } else {
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
};

export const parsePostgresInterval = intervalString => {
    const regex = /(?:(\d+)d\s*)?(?:(\d+)h\s*)?(?:(\d+)m\s*)?/;
    const matches = intervalString.match(regex);

    const days = parseInt(matches[1]) || 0;
    const hours = parseInt(matches[2]) || 0;
    const minutes = parseInt(matches[3]) || 0;

    return {
        days,
        hours,
        minutes,
    };
};

export const addDurationToDate = (isoDate, duration) => {
    const regex = /(\d{1,2})d\s?(\d{1,2})?h?\s?(\d{1,2})?m?/;
    const match = duration?.match(regex);
    if (match) {
        const days = parseInt(match[1]) || 0;
        const hours = parseInt(match[2]) || 0;
        const minutes = parseInt(match[3]) || 0;
        const date = new Date(isoDate);
        date.setDate(date.getDate() + days);
        date.setHours(date.getHours() + hours);
        date.setMinutes(date.getMinutes() + minutes);
        return date.toISOString();
    } else {
        return null;
    }
};

export const getQueryParams = (data = {}) => {
    const urlSearchParams = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(el => {
                urlSearchParams.append(key, el);
            });
        } else {
            if (value) urlSearchParams.append(key, value);
        }
    });

    return urlSearchParams.toString();
};

export const changeLocaleCountries = (arr, locale) => {
    const names = new Intl.DisplayNames([`${locale}`], { type: 'region' });
    let newArr = [];
    newArr = arr.map(elem => { return { alpha2: elem.alpha2, value: names.of(elem.alpha2) }; });
    return newArr;
};

export const sliceArr = (arr, size) => {
    const resultArr = [];
    while (arr.length > 0) { resultArr.push(arr.splice(0, size)); }
    return resultArr;
};

export const getUserColor = (nickname = '', avatarUrl = '', colors = PERMITTED_CHAT_COLORS) => {
    const hashNumber = hash(nickname + avatarUrl);
    const colorIndex = randomSeed(hashNumber).intBetween(0, colors.length - 1);
    return colors[colorIndex];
};

export const getClearedUserMessage = (message = '') => {
    return message.replaceAll(/\n{2,}/g, '\n');
};
